import React from 'react'
import { Box } from '@mui/material'
import { ClockIcon } from '@heroicons/react/24/outline'
import { INTERAX_COLORS } from '../constants/colors'

interface TimeDisplayProps {
  time: string
  status: 'live' | 'upcoming' | 'completed'
}

export const TimeDisplay: React.FC<TimeDisplayProps> = ({ time, status }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 1.5,
        py: 0.5,
        borderRadius: '9999px',
        backgroundColor: status === 'live' ? INTERAX_COLORS.greenBackground : INTERAX_COLORS.sun20,
        flex: '0 0 auto'
      }}
    >
      <ClockIcon className="w-4 h-4" style={{ color: status === 'live' ? INTERAX_COLORS.green : INTERAX_COLORS.sun }} />
      <Box
        sx={{
          fontSize: '0.875rem',
          fontWeight: '500',
          color: status === 'live' ? INTERAX_COLORS.green : INTERAX_COLORS.sun
        }}
      >
        {time}
      </Box>
    </Box>
  )
}

export default TimeDisplay
